import { render } from "./DrugTestReport.vue?vue&type=template&id=07c96905&ts=true"
import script from "./DrugTestReport.vue?vue&type=script&lang=ts"
export * from "./DrugTestReport.vue?vue&type=script&lang=ts"

import "./DrugTestReport.vue?vue&type=style&index=0&id=07c96905&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__